import { UseCustomAxios } from "../../../UseCustomAxios";
import { useSnackbar } from "notistack";
import { isEmpty } from "../../../util/Utils";

export function UseOffer() {
  const MyAxios = UseCustomAxios();
  const { enqueueSnackbar } = useSnackbar();
  const { toGregorian, toSolar } = require("jdate-convert");

  function validate2(state, setter) {
    let errorState = {
      title: isEmpty(state.title),
      productCount: isEmpty(state.productCount),
    };

    setter(errorState);

    if (errorState.title || errorState.productCount) {
      enqueueSnackbar("لطفا اطلاعات را کامل وارد کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return 500;
    } else {
      return 200;
    }
  }
  function validate(state, setter) {
    let errorState = {
      type: isEmpty(state.type),
      filter: isEmpty(state.filter),
      categoryID: isEmpty(state.categoryID),
      groupID: isEmpty(state.groupID),
      brandID: isEmpty(state.brandID),
    };

    setter(errorState);

    if (errorState.type || errorState.filter) {
      enqueueSnackbar("لطفا اطلاعات را کامل وارد کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return 500;
    } else if (state.filter == 1 && errorState.categoryID) {
      enqueueSnackbar("لطفا نوع دسته را انتخاب کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return 500;
    } else if (state.filter == 2 && errorState.brandID) {
      enqueueSnackbar("لطفا برند را انتخاب کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return 500;
    } else if (state.filter == 3 && errorState.groupID) {
      enqueueSnackbar("لطفا گروه را انتخاب کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return 500;
    } else {
      return 200;
    }
  }

  const HomeOffer = (OfferID, callback) => {
    MyAxios.get(`Admin_HomeOffer`, {
      headers: {
        AID: OfferID,
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const UpdateOfferInformation = (state, icon, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    if (icon) {
      data.append("Icon", icon);
    }
    MyAxios.put(`Admin_HomeOffer`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("اطلاعات با موفقیت ویرایش شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback(response.data.resault);
      }
    });
  };

  const AddOfferInformation = (state, icon, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    if (icon) {
      data.append("Icon", icon);
    }
    MyAxios.post(`Admin_HomeOffer`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("اطلاعات با موفقیت افزوده شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback(response.data.resault);
      }
    });
  };

  const UpdateOffersList = (state, callback) => {
    MyAxios.post(`Admin_HomeOffer/UpdateOffers`).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const AddOfferProduct = (state, callback) => {
    state = removeSomeProps(state);

    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_HomeOffer/AddOffer`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("محصول با موفقیت افزوده شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback(response.data.resault);
      }
    });
  };

  const UpdateOfferProduct = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.put(`Admin_HomeOffer/OfferProduct`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("اولویت محصول با موفقیت ویرایش شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback(response.data.resault);
      }
    });
  };

  const deleteOfferProduct = (OfferProductID, callback) => {
    const data = new FormData();
    data.append("OfferProductID", OfferProductID);
    MyAxios.delete(`Admin_HomeOffer/OfferProduct`, { data: data }).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          enqueueSnackbar("محصول با موفقیت حذف شد", {
            variant: "success",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
          callback();
        }
      }
    );
  };

  const GetProductsByWord = (search, callback) => {
    MyAxios.get(`Admin_NewOrder/GetProductsByWord?w=${search}`).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          callback(response.data.resault);
        }
      }
    );
  };

  const UpdateOffers = () => {
    MyAxios.post(`Admin_HomeOffer/UpdateOffers`).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("به‌روزرسانی لیست محصول انجام شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
      }
    });
  };

  const UpdateOffersAll = (callback) => {
    MyAxios.post(`Admin_HomeOffer/UpdateOffers`).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback();
        enqueueSnackbar("به‌روزرسانی لیست محصول انجام شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
      }
    });
  };

  const UpdateOffersData = (OfferID) => {
    const data = new FormData();
    data.append("OfferID", OfferID);
    MyAxios.post(`Admin_HomeOffer/UpdateOffersData`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("به‌روزرسانی محصولات لیست انجام شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
      }
    });
  };

  const UpdateOffersDataAll = (callback) => {
    MyAxios.post(`Admin_HomeOffer/UpdateOffersData`).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback();
        enqueueSnackbar("به‌روزرسانی محصولات لیست انجام شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
      }
    });
  };

  const removeSomeProps = (model) => {
    delete model.filter;
    if (model.brandID == undefined) {
      delete model.brandID;
    }
    if (model.categoryID == undefined) {
      delete model.categoryID;
    }
    if (model.groupID == undefined) {
      delete model.groupID;
    }
    if (model.type == undefined) {
      delete model.type;
    }
    if (model.productID == undefined) {
      delete model.productID;
    }
    return model;
  };

  return {
    validate,
    validate2,
    HomeOffer,
    UpdateOfferInformation,
    AddOfferInformation,
    UpdateOffersList,
    AddOfferProduct,
    UpdateOfferProduct,
    deleteOfferProduct,
    GetProductsByWord,
    UpdateOffers,
    UpdateOffersData,
    UpdateOffersDataAll,
    UpdateOffersAll,
  };
}
